import React from 'react';
import { Sunrise, Clock, CalendarFold, Users, MapPin, AlarmClock, Text, ListCheck, AlignLeft } from 'lucide-react'

const QuestionIcons = ({ type }) => {

    const iconMap = {
      date: <Sunrise />,
      date_time: <Clock />,
      calendar: <CalendarFold />,
      people: <Users />,
      location: <MapPin />,
      duration: <AlarmClock />,
      description: <Text />,
      list: <ListCheck />,
      open: <AlignLeft />,
    };

    return iconMap[type?.toLowerCase()] || <AlignLeft />; 
  };

export default QuestionIcons;
